import * as R from 'ramda'
import { useContextSelector } from 'use-context-selector'

import { IDENTITY } from 'constants/commonConstans'

import { FormContext } from './Form'
import type { IFieldConfig } from './types'

export const useFormFieldValues = (config: IFieldConfig) => {
  const { name, defaultValue: cfgDef, getter = IDENTITY } = config

  const def = useContextSelector(FormContext, (с) => R.path(name.split('.'), с.defaultValues))
  const inherit = useContextSelector(FormContext, (с) => R.path(name.split('.'), с.inheritValues))
  const initial = useContextSelector(FormContext, (с) => R.path(name.split('.'), с.initialValues))
  const value = useContextSelector(FormContext, (с) => R.path(name.split('.'), с.values))

  return {
    defaultValue: [getter(inherit), getter(cfgDef), getter(def)].find((v) => v !== undefined),
    initialValue: getter(initial),
    value: getter(value),
  }
}
